'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');
const DateTime = require('@grpn/preact-l10n/datetime');

function OfferExpiry({ className = '', expires }) {
  return (
    expires &&
    h(`span.${className}`, [
      h(Translate, 'js.modules.widget.Expires'),
      ' ',
      h(DateTime, { value: expires, format: 'L' }),
    ])
  );
}

module.exports = OfferExpiry;
